export const TENANT_PANASONIC_URI = "panasonic"
export const TENANT_FLIPKART_URI = "smarthomeplus"
export const TENANT_AMAZON_URI = "appliancehub"
export const ISD_CODES = [
  { iso: "in", code: "+91", label: "India (+91)" },
  { iso: "bd", code: "+880", label: "Bangladesh (+880)" },
  { iso: "lk", code: "+94", label: "Sri Lanka (+94)" },
  { iso: "np", code: "+977", label: "Nepal (+977)" },
  { iso: "sg", code: "+65", label: "Singapore (+65)" },
  { iso: "th", code: "+66", label: "Thailand (+66)" },
  { iso: "jp", code: "+81", label: "Japan (+81)" },
];
